export default __webpack_public_path__ + "fad567098493bac8f1ea0d207cb59f57.png";